import { Img, Section, TextBlock, Text, Title, StyledLinkButton } from "./styled";
import img from "./image.jpg";
import { path } from "../../../settings";

const AboutSugaring = () => {
    return (
        <Section >
            <TextBlock>
                <Title>Правильно вибрана паста для шугарингу є основою хорошої депіляції</Title>
                <Text>
                    Я зробила свій вибір на продукції української марки "Sugarlen" 🥰
                    Можу без сумнівів сказати, що це найкращі продукти призначені для депіляції та догляду за шкірою.
                    У складі пасти базове тріо з якого складається паста для шугарингу - це вода,
                    цукор та лимонний🍋 сік.
                    Під впливом високих температур 🔥 цукор розпадається на фруктозу,сахарозу та глюкозу.
                    Саме фруктоза забезпечує щеплення з волосками, прилипаючи до них.
                </Text>
                <StyledLinkButton to={path.more}>Дізнатись більше</StyledLinkButton>
            </TextBlock>
            <Img src={img} />
        </Section>
    )
};

export default AboutSugaring;